import React from "react"
import { Button, Icon, Menu } from "semantic-ui-react"
import { Link } from "react-router-dom"
import CartButton from "components/Cart/CartButton"
import shop from "shop/shop"
import app from "app.controller"

import MenuBySlug from "components/Menu/MenuBySlug"
import { MegaMenuBig } from "./Header.js"


const StickyHeader = () => <div
	className="StickyHeader mini-header z-9 fixed top-0 left-0 right-0 bg-white animate fadeInDown">
	<div className="ph2">
		<MenuBySlug slug={"header"}
					key={"mini-header-main"}
					secondary
					borderless>
			<Menu.Item>
				<Button basic icon={"home"} as={Link} to="/"/>
			</Menu.Item>
			{ /** <Menu.Item
				onClick={app.sidebarLeft.toggle.dispatch}><Icon
				name="bars"/></Menu.Item> **/ }
			<Menu.Item
				position="right"
				content={translate( "Orderlist" )}
				as={Link}
				to="/orderlist"/>
			<Menu.Item
				as={Link}
				to="/search"><Icon name="search"/></Menu.Item>
			{shop.session && <Menu.Item><CartButton/></Menu.Item>}
		</MenuBySlug>
	</div>
	<div>
		<MegaMenuBig/>
	</div>
</div>

export default StickyHeader



// WEBPACK FOOTER //
// ./src/theme/oehme/components/Header/StickyHeader.js